import React, { useEffect, useState } from 'react'
import { useAuth } from 'contexts/AuthContext'
import prefetchSideMenu from 'graphql/prefetchers/prefetchSideMenu'
import { initializeApollo } from 'lib/apolloClient'
import { useTranslation } from 'lib/i18n'
import config from 'lib/nextConfig'
import { isServer } from 'lib/utils'
import { NextPage, NextPageContext } from 'next'
import querystring from 'querystring'

import ContentPage from 'components/ContentPage/ContentPage'
import MagicLinkForm from 'components/MagicLinkForm/MagicLinkForm'
import PublicLayout from 'components/PublicLayout/PublicLayout'
import Spinner from 'components/Spinner/Spinner'
import useRouter from 'hooks/useRouter'

const LoginPage: NextPage = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const { isAuthenticated, loginEmailPrefill, loading } = useAuth()
  const [showLogin, setShowLogin] = useState(false)

  const { goto } = router.query

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
        if (goto) {
          router.push(goto.toString())
        } else {
          router.push('/account/orders')
        }
      } else {
        setShowLogin(true)
      }
    }
  }, [goto, isAuthenticated, loading, router])

  return (
    <PublicLayout hidePress>
      {isAuthenticated && <Spinner centered />}
      {!isAuthenticated && showLogin && (
        <ContentPage centered title={t('LoginPage.title', 'Sign in')}>
          <MagicLinkForm emailPrefill={loginEmailPrefill} />
        </ContentPage>
      )}
    </PublicLayout>
  )
}

LoginPage.getInitialProps = async (ctx: NextPageContext) => {
  // req should have the type IncomingMessage, but that doesn't have _parsedUrl
  const req = ctx.req as unknown as
    | { _parsedUrl: { pathname: string } }
    | undefined
  const { query, res } = ctx

  if (isServer()) {
    const apolloClient = initializeApollo(ctx)

    if (query.token) {
      const { token, goto } = query
      const queryString = goto ? querystring.stringify({ goto }) : ''
      res.setHeader('Set-Cookie', [
        `tempToken=${token}; Path=${config.basePath || '/'}; Max-Age=600`,
        'token=; Max-Age=0',
      ])

      res.writeHead(302, {
        // eslint-disable-next-line no-underscore-dangle
        Location: `${config.basePath}${req._parsedUrl.pathname}?${queryString}`,
      })
      res.end()
    }

    await prefetchSideMenu(apolloClient)

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }
  return {}
}

export default LoginPage
